module.exports = __webpack_public_path__ + "static/media/next.460e0b69.svg";